<template>
  <v-container fluid class="pa-sm-6 print-page">
    <slot name="default" />
  </v-container>
</template>

<script lang="ts" setup></script>

<style lang="css">
@media print {
  .print-page {
    padding: 0 !important;
  }

  .v-card {
    box-shadow: none;
  }
}
</style>
